import { render, staticRenderFns } from "./TargetData.vue?vue&type=template&id=2f25200c&scoped=true"
import script from "./TargetData.vue?vue&type=script&lang=js"
export * from "./TargetData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25200c",
  null
  
)

export default component.exports